
import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import api from "../../api/api"; 
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};
// -----------------------------------------------------

export default function ProductionByPart({ AssetID }) {
  const [parts, setParts] = useState([]);
  const [wcOptions, setWcOptions] = useState([]);
  const [selectedPart, setSelectedPart] = useState(null);
  const [selectedWc, setSelectedWc] = useState(null);
  const [maxQty, setMaxQty] = useState(0); 
  const [calibrationQty, setCalibrationQty] = useState(0); 

  const [editingItem, setEditingItem] = useState(null); 
  
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); 

  const [openingQty, setOpeningQty] = useState(0);
const [openingDate, setOpeningDate] = useState("");

  const userName = sessionStorage.getItem("userName");
  const storedAssetId = parseInt(sessionStorage.getItem("currentAssetId")) || 0;

  const getToday = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

  const handleCloseModal = () => {
    setEditingItem(null);
    setSelectedPart(null);
    setSelectedWc(null);
    setMaxQty(0);
    setCalibrationQty(0);
    setIsModalOpen(false);
    setOpeningQty(0);
setOpeningDate("");
  };

  const fetchPartsAndWc = async () => {
    try {
      setLoading(true);
      const response = await api.GetAssetPrdItemAPI(userName);
      const partTable = response?.Table || response?.data?.Table || [];
      const wcTable = response?.Table1 || response?.data?.Table1 || [];

      setParts(
        (partTable || []).map((item) => ({
          value: item.itemid,
          label: `${item.Item_No} - ${item.Item_Desc1}`,
          Item_No: item.Item_No,
          Item_Desc1: item.Item_Desc1,
          itemid: item.itemid,
        }))
      );

      setWcOptions(
        (wcTable || []).map((item) => ({
          value: item.WcId,
          label: item.WcName?.trim() || "Unnamed WC",
          WcId: item.WcId,
          WcName: item.WcName?.trim() || "",
        }))
      );
    } catch (error) {
      console.error("❌ Error fetching dropdowns:", error);
      alert("Failed to load dropdowns.");
    } finally {
      setLoading(false);
    }
  };

  const fetchExistingData = useCallback(async () => {
    try {
      const assetIdToUse = AssetID || storedAssetId;
      if (!assetIdToUse) return;

      const response = await api.EditAssetPrdItem_API(assetIdToUse);
      const table = response?.Table || response || [];

      setGridData(
        Array.isArray(table)
          ? table.map((x) => ({
              SeqId: x.Seqid,
              AssetId: x.AssetId,
              ItemId: x.ItemId,
              PartNo: x.PartNo,
              PartDesc: x.PartDesc,
              WcId: x.Wcid,
              WcName: x.Wcname,
              MaxQty: x.maxqty || 0,
              CalibrationQty: x.calibrationqty || 0,
              TotalProd: x.TotalProd || 0, 
              OpeningQty: x.OpeningQty || 0,
OpeningDate: x.OpeningDate || null,
            }))
          : []
      );
    } catch (error) {
      console.error("❌ Error loading data:", error);
    }
  }, [AssetID, storedAssetId]);
  
  const handleSavePart = async () => {
  // Input validation
  if (!selectedPart) return alert("Select Part No first!");
  if (!selectedWc) return alert("Select Work Center first!");

  const finalMaxQty = Number(maxQty);
  const finalCalibQty = Number(calibrationQty);

  if (
    finalMaxQty < 0 ||
    finalCalibQty < 0 ||
    isNaN(finalMaxQty) ||
    isNaN(finalCalibQty)
  ) {
    return alert("Quantities must be non-negative numbers!");
  }

  // ✅ NEW VALIDATION: Calibration Qty must be LESS than Max Qty
 if (finalMaxQty === 0 && finalCalibQty === 0) {
  // Both are zero → allow
} else if (finalCalibQty >= finalMaxQty) {
  return alert("Calibration Qty must be less than Max Qty!");
}

  const assetIdToUse = AssetID || storedAssetId;
  const isEditing = !!editingItem;
  const action = isEditing ? "UPDATE" : "INSERT";

  if (action === "INSERT") {
    const exists = gridData.some(
      (item) =>
        item.ItemId === selectedPart.itemid && item.WcId === selectedWc.WcId
    );
    if (exists) return alert("This Part No already exists for this WC!");
  }

  const newRow = {
    AssetId: assetIdToUse,
    SeqId: isEditing ? editingItem.SeqId : 0,
    ItemId: selectedPart.itemid,
    PartNo: selectedPart.Item_No,
    PartDesc: selectedPart.Item_Desc1,
    WcId: selectedWc.WcId,
    WcName: selectedWc.WcName,
    MaxQty: finalMaxQty,
    CalibrationQty: finalCalibQty,
     OpeningQty: openingQty,
  OpeningDate: openingDate,
  };

  try {
    setSaving(true);
    await api.SaveAssetprdItemAPI({
      Sp_SqlAction: action,
      ...newRow,
    });

    handleCloseModal();
    await fetchExistingData();
  } catch (error) {
    console.error(`❌ Error ${action} part:`, error);
    alert(`Failed to ${action.toLowerCase()} part!`);
  } finally {
    setSaving(false);
  }
};


  const handleDelete = async (SeqId) => {
    if (!window.confirm("Delete this record?")) return;
    try {
      setLoading(true);
      const assetIdToUse = AssetID || storedAssetId;
      await api.DeleteAssetPrdItemAPI(assetIdToUse, SeqId);
      await fetchExistingData();
    } catch (error) {
      console.error("❌ Delete error:", error);
      alert("Failed to delete record.");
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    const load = async () => {
      await fetchPartsAndWc();
      if (AssetID > 0) await fetchExistingData();
    };
    load();
  }, [AssetID, fetchExistingData]); 

  const handleOpenModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setSelectedPart({
        value: item.ItemId,
        label: `${item.PartNo} - ${item.PartDesc}`,
        Item_No: item.PartNo,
        Item_Desc1: item.PartDesc,
        itemid: item.ItemId,
      });
      setSelectedWc(wcOptions.find(wc => wc.WcId === item.WcId) || {value: item.WcId, label: item.WcName, WcId: item.WcId, WcName: item.WcName});
      setMaxQty(item.MaxQty);
      setCalibrationQty(item.CalibrationQty);
      setOpeningQty(item.OpeningQty);
setOpeningDate(item.OpeningDate ? item.OpeningDate.split("T")[0] : "");
      setIsModalOpen(true);
   } else {
  handleCloseModal();

  // Set default fields for Add Mode
  setOpeningDate(getToday());   // <-- AUTO SET CURRENT DATE
  setOpeningQty(0);

  setIsModalOpen(true);
}
  };

  return (
    <div className="production-container">

<style>{`
  /* ============================================================
    BASE CONTAINER STYLES
    ============================================================ */
  .production-container {
    padding: 16px; 
    background: #f7f9fc; 
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    max-width: 100%;
  }

  .production-title {
    font-size: 1.25rem; 
    font-weight: 600;
    color: #1a3c69; 
    margin: 0; /* Remove default margin */
  }
  
  .header-with-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #e0e6ed; 
    margin-bottom: 16px;
  }
  
  /* NEW: Button container */
  .header-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  /* ============================================================
    BUTTON STYLES
    ============================================================ */
  .add-btn, .open-modal-btn, .export-btn { 
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    height: 38px; 
    transition: background-color 0.2s, box-shadow 0.2s;
    font-size: 0.9rem;
    /* Added to center icon/text */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* Specific styles for text buttons (to maintain previous appearance) */
  .add-btn, .open-modal-btn {
    padding: 8px 16px;
    min-width: 90px;
  }
  
  .open-modal-btn { 
    background: #007bff; 
    color: #fff;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2); 
  }
  .open-modal-btn:hover { 
    background: #0056b3; 
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }
  
  /* UPDATED: Export button style (Icon button) */
  .export-btn {
    background: #6c757d; /* Gray color for export */
    color: #fff;
    /* Styles for icon button */
    width: 38px;
    padding: 0;
    min-width: 38px;
    box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);
  }
  .export-btn:hover {
    background: #5a6268;
    box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
  }
  
  .add-btn:disabled, .open-modal-btn:disabled, .export-btn:disabled {
    background: #1199e7ff;
    cursor: not-allowed;
    box-shadow: none;
    color: #eef5f5ff;
  }
  
  /* NEW: Edit button style */
  .edit-btn {
      background: #ffc107; /* Yellow/Orange for edit */
      color: #333;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: 500;
      padding: 6px 10px;
      font-size: 0.75rem;
      transition: background-color 0.2s;
      margin-right: 4px;
  }
  .edit-btn:hover { background: #e0a800; }
  
  /* ============================================================
    FORM FIELD STYLES (Applies inside Modal)
    ============================================================ */
  .field-group {
    margin-bottom: 16px; 
  }

  label.production-label {
    font-weight: 600;
    font-size: 0.8rem;
    color: #333;
    margin-bottom: 4px; 
    display: block; 
  }
  
  /* Input styling for Max Qty and Calib Qty */
  .quantity-group {
    display: flex;
    gap: 16px; 
    margin-bottom: 16px;
  }
  .quantity-group input[type="number"] {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ccc; 
      border-radius: 6px;
      font-size: 0.9rem;
      box-sizing: border-box;
      transition: border-color 0.2s, box-shadow 0.2s;
  }
  .quantity-group input[type="number"]:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
      outline: none;
  }
  
  /* React-Select Overrides for consistency */
  .select-container .select__control {
    border-radius: 6px !important;
    min-height: 38px !important;
    font-size: 0.9rem !important;
    box-shadow: none !important;
    border-color: #ccc !important;
  }
  .select-container .select__control--is-focused {
    border-color: #007bff !important;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25) !important;
  }

  /* Specific styles for disabled select controls in edit mode */
  .select__control--is-disabled {
    background-color: #f8f9fa !important;
    cursor: not-allowed;
  }


  /* ============================================================
    TABLE STYLES
    ============================================================ */
  .table-wrapper {
    max-height: 360px;
    overflow-y: auto;
    border: 1px solid #e0e6ed;
    border-radius: 8px; 
    background: #fff;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem; 
  }

  th, td {
    padding: 10px 12px; 
    text-align: left; 
    border-bottom: 1px solid #f0f0f0;
    white-space: nowrap;
  }
  th:first-child, td:first-child,
  th:last-child, td:last-child {
    text-align: center; 
  }

  th {
    position: sticky;
    top: 0;
    background: #e9ecef; 
    color: #495057; 
    font-weight: 600;
    z-index: 1;
  }

  tr:nth-child(even) { background: #f8f9fa; } 
  tr:hover { background: #e9f5ff; } 

  .delete-btn {
    background: #dc3545; 
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    padding: 6px 10px;
    font-size: 0.75rem;
    transition: background-color 0.2s;
  }
  .delete-btn:hover { background: #c82333; }

  /* ============================================================
    MODAL STYLES (PROFESSIONAL LOOK)
    ============================================================ */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6); 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background: #fff;
    padding: 24px; 
    border-radius: 12px; 
    width: 95%;
    max-width: 500px; 
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); 
    animation: fadeIn 0.3s ease-out;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95) translateY(10px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 2px solid #f0f0f0; 
    padding-bottom: 12px;
  }

  .modal-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #1a3c69;
    margin: 0;
  }

  .modal-close-btn {
    background: none;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    color: #6c757d; 
    line-height: 1;
    transition: color 0.2s;
  }
  .modal-close-btn:hover {
    color: #333;
  }

  .modal-body .add-btn {
    margin-top: 20px; 
  }
  

  .date-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 0.9rem;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
    background-color: #fff;
}

.date-input:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    outline: none;
    background-color: #fff;
}

/* Calendar icon visibility fix (for Chrome/Edge) */
.date-input::-webkit-calendar-picker-indicator {
    cursor: pointer;
    filter: opacity(0.7);
}

.date-input:disabled {
    background: #f3f3f3;
    cursor: not-allowed;
}

  /* ============================================================
    RESPONSIVENESS
    ============================================================ */
  @media (max-width: 768px) {
    .quantity-group { 
      flex-direction: column; 
      gap: 10px; 
    } 
    .modal-content {
        max-width: 90%;
        margin: 20px;
    }
  }
`}</style>

      <div className="header-with-button">
        <h2 className="production-title">Production by Part</h2>
        <div className="header-buttons">
       <ExcelExport data={gridData} fileName="ProductionByPart" />

          <button className="open-modal-btn" onClick={() => handleOpenModal()} disabled={loading}>
            Add Part
          </button>
        </div>
      </div>

      <div className="table-wrapper">
        {loading ? (
            <p style={{textAlign: "center", padding: "20px"}}>Loading data...</p>
        ) : gridData.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Part No</th>
                <th>Work Center</th>
                <th>Max Qty</th> 
                <th>Calibration Qty</th>
                <th>Total Prod</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {gridData.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{row.PartNo} ({row.PartDesc})</td>
                  <td>{row.WcName}</td>
                  <td>{row.MaxQty}</td>
                  <td>{row.CalibrationQty}</td>
                  <td>{row.TotalProd}</td>
                  <td style={{ textAlign: 'center' }}>
                    <button
                      className="edit-btn"
                      onClick={() => handleOpenModal(row)}
                      disabled={loading}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(row.SeqId)}
                      disabled={loading}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p
            style={{
              textAlign: "center",
              color: "#6b7280",
              marginTop: "8px",
              fontSize: "0.85rem",
              padding: "10px", 
            }}
          >
            No parts added yet.
          </p>
        )}
      </div>
      
      <Modal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
        title={editingItem ? "Edit Part Configuration" : "Add Production Part Configuration"} // Dynamic title
      >
        <div className="modal-body">
         <div className="field-group">
            <label className="production-label">Work Center</label>
            <Select
              options={wcOptions}
              value={selectedWc}
              onChange={setSelectedWc}
              isClearable={!editingItem} 
              isDisabled={loading || saving || !!editingItem} 
              placeholder={loading ? "Loading..." : "Select Work Center..."}
              classNamePrefix="select"
            />
          </div>

          <div className="field-group">
            <label className="production-label">Part No</label>
            <Select
              options={parts}
              value={selectedPart}
              onChange={setSelectedPart}
              isClearable={!editingItem} 
              isDisabled={loading || saving || !!editingItem} 
              placeholder={loading ? "Loading..." : "Select Part No..."}
              classNamePrefix="select"
            />
          </div>
          
          <div className="quantity-group">
            <div className="field-group">
              <label className="production-label" htmlFor="max-qty">Max Qty</label>
              <input
                id="max-qty"
                type="number"
                min="0"
                value={maxQty}
                onChange={(e) => setMaxQty(Number(e.target.value))}
                disabled={loading || saving}
                placeholder="0"
              />
            </div>

            <div className="field-group">
              <label className="production-label" htmlFor="calib-qty">Calibration Qty</label>
              <input
                id="calib-qty"
                type="number"
                min="0"
                value={calibrationQty}
                onChange={(e) => setCalibrationQty(Number(e.target.value))}
                disabled={loading || saving}
                placeholder="0"
              />
            </div>
          </div>
<div className="quantity-group">
  
  <div className="field-group">
    <label className="production-label">Opening Qty</label>
    <input
      type="number"
      min="0"
      value={openingQty}
      onChange={(e) => setOpeningQty(Number(e.target.value))}
      disabled={loading || saving}
      placeholder="0"
    />
  </div>
<div className="field-group">
  <label className="production-label">Opening Date</label>
  <input
    type="date"
    className="date-input"
    value={openingDate}
    onChange={(e) => setOpeningDate(e.target.value)}
    disabled={loading || saving}
  />
</div>

</div>


          <button
            className="add-btn"
            onClick={handleSavePart} 
            disabled={saving || loading || !selectedPart || !selectedWc}
          >
            {saving 
              ? "Saving..." 
              : editingItem 
                ? "Update Configuration" 
                : "Add Part to Asset"}
          </button>
        </div>
      </Modal>

    </div>
  );
}

// import React, { useEffect, useState, useCallback } from "react";
// import Select from "react-select";
// import api from "../../api/api"; 
// import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

// const Modal = ({ isOpen, onClose, title, children }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="modal-content">
//         <div className="modal-header">
//           <h3 className="modal-title">{title}</h3>
//           <button className="modal-close-btn" onClick={onClose}>
//             &times;
//           </button>
//         </div>
//         <div className="modal-body">{children}</div>
//       </div>
//     </div>
//   );
// };
// // -----------------------------------------------------

// export default function ProductionByPart({ AssetID }) {
//   const [parts, setParts] = useState([]);
//   const [wcOptions, setWcOptions] = useState([]);
//   const [selectedPart, setSelectedPart] = useState(null);
//   const [selectedWc, setSelectedWc] = useState(null);
//   const [maxQty, setMaxQty] = useState(0); 
//   const [calibrationQty, setCalibrationQty] = useState(0); 

//   const [editingItem, setEditingItem] = useState(null); 
  
//   const [gridData, setGridData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false); 

//   const userName = sessionStorage.getItem("userName");
//   const storedAssetId = parseInt(sessionStorage.getItem("currentAssetId")) || 0;

//   const handleCloseModal = () => {
//     setEditingItem(null);
//     setSelectedPart(null);
//     setSelectedWc(null);
//     setMaxQty(0);
//     setCalibrationQty(0);
//     setIsModalOpen(false);
//   };

//   const fetchPartsAndWc = async () => {
//     try {
//       setLoading(true);
//       const response = await api.GetAssetPrdItemAPI(userName);
//       const partTable = response?.Table || response?.data?.Table || [];
//       const wcTable = response?.Table1 || response?.data?.Table1 || [];

//       setParts(
//         (partTable || []).map((item) => ({
//           value: item.itemid,
//           label: `${item.Item_No} - ${item.Item_Desc1}`,
//           Item_No: item.Item_No,
//           Item_Desc1: item.Item_Desc1,
//           itemid: item.itemid,
//         }))
//       );

//       setWcOptions(
//         (wcTable || []).map((item) => ({
//           value: item.WcId,
//           label: item.WcName?.trim() || "Unnamed WC",
//           WcId: item.WcId,
//           WcName: item.WcName?.trim() || "",
//         }))
//       );
//     } catch (error) {
//       console.error("❌ Error fetching dropdowns:", error);
//       alert("Failed to load dropdowns.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchExistingData = useCallback(async () => {
//     try {
//       const assetIdToUse = AssetID || storedAssetId;
//       if (!assetIdToUse) return;

//       const response = await api.EditAssetPrdItem_API(assetIdToUse);
//       const table = response?.Table || response || [];

//       setGridData(
//         Array.isArray(table)
//           ? table.map((x) => ({
//               SeqId: x.Seqid,
//               AssetId: x.AssetId,
//               ItemId: x.ItemId,
//               PartNo: x.PartNo,
//               PartDesc: x.PartDesc,
//               WcId: x.Wcid,
//               WcName: x.Wcname,
//               MaxQty: x.maxqty || 0,
//               CalibrationQty: x.calibrationqty || 0,
//               TotalProd: x.TotalProd || 0, 
//             }))
//           : []
//       );
//     } catch (error) {
//       console.error("❌ Error loading data:", error);
//     }
//   }, [AssetID, storedAssetId]);
  
//   const handleSavePart = async () => {
//   // Input validation
//   if (!selectedPart) return alert("Select Part No first!");
//   if (!selectedWc) return alert("Select Work Center first!");

//   const finalMaxQty = Number(maxQty);
//   const finalCalibQty = Number(calibrationQty);

//   if (
//     finalMaxQty < 0 ||
//     finalCalibQty < 0 ||
//     isNaN(finalMaxQty) ||
//     isNaN(finalCalibQty)
//   ) {
//     return alert("Quantities must be non-negative numbers!");
//   }

//   // ✅ NEW VALIDATION: Calibration Qty must be LESS than Max Qty
//  if (finalMaxQty === 0 && finalCalibQty === 0) {
//   // Both are zero → allow
// } else if (finalCalibQty >= finalMaxQty) {
//   return alert("Calibration Qty must be less than Max Qty!");
// }

//   const assetIdToUse = AssetID || storedAssetId;
//   const isEditing = !!editingItem;
//   const action = isEditing ? "UPDATE" : "INSERT";

//   if (action === "INSERT") {
//     const exists = gridData.some(
//       (item) =>
//         item.ItemId === selectedPart.itemid && item.WcId === selectedWc.WcId
//     );
//     if (exists) return alert("This Part No already exists for this WC!");
//   }

//   const newRow = {
//     AssetId: assetIdToUse,
//     SeqId: isEditing ? editingItem.SeqId : 0,
//     ItemId: selectedPart.itemid,
//     PartNo: selectedPart.Item_No,
//     PartDesc: selectedPart.Item_Desc1,
//     WcId: selectedWc.WcId,
//     WcName: selectedWc.WcName,
//     MaxQty: finalMaxQty,
//     CalibrationQty: finalCalibQty,
//   };

//   try {
//     setSaving(true);
//     await api.SaveAssetprdItemAPI({
//       Sp_SqlAction: action,
//       ...newRow,
//     });

//     handleCloseModal();
//     await fetchExistingData();
//   } catch (error) {
//     console.error(`❌ Error ${action} part:`, error);
//     alert(`Failed to ${action.toLowerCase()} part!`);
//   } finally {
//     setSaving(false);
//   }
// };


//   const handleDelete = async (SeqId) => {
//     if (!window.confirm("Delete this record?")) return;
//     try {
//       setLoading(true);
//       const assetIdToUse = AssetID || storedAssetId;
//       await api.DeleteAssetPrdItemAPI(assetIdToUse, SeqId);
//       await fetchExistingData();
//     } catch (error) {
//       console.error("❌ Delete error:", error);
//       alert("Failed to delete record.");
//     } finally {
//       setLoading(false);
//     }
//   };
 
//   useEffect(() => {
//     const load = async () => {
//       await fetchPartsAndWc();
//       if (AssetID > 0) await fetchExistingData();
//     };
//     load();
//   }, [AssetID, fetchExistingData]); 

//   const handleOpenModal = (item = null) => {
//     if (item) {
//       setEditingItem(item);
//       setSelectedPart({
//         value: item.ItemId,
//         label: `${item.PartNo} - ${item.PartDesc}`,
//         Item_No: item.PartNo,
//         Item_Desc1: item.PartDesc,
//         itemid: item.ItemId,
//       });
//       setSelectedWc(wcOptions.find(wc => wc.WcId === item.WcId) || {value: item.WcId, label: item.WcName, WcId: item.WcId, WcName: item.WcName});
//       setMaxQty(item.MaxQty);
//       setCalibrationQty(item.CalibrationQty);
//       setIsModalOpen(true);
//     } else {

//       handleCloseModal(); 
//       setIsModalOpen(true); 
//     }
//   };

//   return (
//     <div className="production-container">

// <style>{`
//   /* ============================================================
//     BASE CONTAINER STYLES
//     ============================================================ */
//   .production-container {
//     padding: 16px; 
//     background: #f7f9fc; 
//     border-radius: 10px;
//     box-shadow: 0 4px 12px rgba(0,0,0,0.05);
//     font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//     max-width: 100%;
//   }

//   .production-title {
//     font-size: 1.25rem; 
//     font-weight: 600;
//     color: #1a3c69; 
//     margin: 0; /* Remove default margin */
//   }
  
//   .header-with-button {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding-bottom: 12px;
//     border-bottom: 1px solid #e0e6ed; 
//     margin-bottom: 16px;
//   }
  
//   /* NEW: Button container */
//   .header-buttons {
//     display: flex;
//     gap: 8px;
//     align-items: center;
//   }

//   /* ============================================================
//     BUTTON STYLES
//     ============================================================ */
//   .add-btn, .open-modal-btn, .export-btn { 
//     border: none;
//     border-radius: 6px;
//     cursor: pointer;
//     font-weight: 500;
//     height: 38px; 
//     transition: background-color 0.2s, box-shadow 0.2s;
//     font-size: 0.9rem;
//     /* Added to center icon/text */
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
  
//   /* Specific styles for text buttons (to maintain previous appearance) */
//   .add-btn, .open-modal-btn {
//     padding: 8px 16px;
//     min-width: 90px;
//   }
  
//   .open-modal-btn { 
//     background: #007bff; 
//     color: #fff;
//     box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2); 
//   }
//   .open-modal-btn:hover { 
//     background: #0056b3; 
//     box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
//   }
  
//   /* UPDATED: Export button style (Icon button) */
//   .export-btn {
//     background: #6c757d; /* Gray color for export */
//     color: #fff;
//     /* Styles for icon button */
//     width: 38px;
//     padding: 0;
//     min-width: 38px;
//     box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);
//   }
//   .export-btn:hover {
//     background: #5a6268;
//     box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
//   }
  
//   .add-btn:disabled, .open-modal-btn:disabled, .export-btn:disabled {
//     background: #1199e7ff;
//     cursor: not-allowed;
//     box-shadow: none;
//     color: #eef5f5ff;
//   }
  
//   /* NEW: Edit button style */
//   .edit-btn {
//       background: #ffc107; /* Yellow/Orange for edit */
//       color: #333;
//       border: none;
//       border-radius: 4px;
//       cursor: pointer;
//       font-weight: 500;
//       padding: 6px 10px;
//       font-size: 0.75rem;
//       transition: background-color 0.2s;
//       margin-right: 4px;
//   }
//   .edit-btn:hover { background: #e0a800; }
  
//   /* ============================================================
//     FORM FIELD STYLES (Applies inside Modal)
//     ============================================================ */
//   .field-group {
//     margin-bottom: 16px; 
//   }

//   label.production-label {
//     font-weight: 600;
//     font-size: 0.8rem;
//     color: #333;
//     margin-bottom: 4px; 
//     display: block; 
//   }
  
//   /* Input styling for Max Qty and Calib Qty */
//   .quantity-group {
//     display: flex;
//     gap: 16px; 
//     margin-bottom: 16px;
//   }
//   .quantity-group input[type="number"] {
//       width: 100%;
//       padding: 8px 12px;
//       border: 1px solid #ccc; 
//       border-radius: 6px;
//       font-size: 0.9rem;
//       box-sizing: border-box;
//       transition: border-color 0.2s, box-shadow 0.2s;
//   }
//   .quantity-group input[type="number"]:focus {
//       border-color: #007bff;
//       box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
//       outline: none;
//   }
  
//   /* React-Select Overrides for consistency */
//   .select-container .select__control {
//     border-radius: 6px !important;
//     min-height: 38px !important;
//     font-size: 0.9rem !important;
//     box-shadow: none !important;
//     border-color: #ccc !important;
//   }
//   .select-container .select__control--is-focused {
//     border-color: #007bff !important;
//     box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25) !important;
//   }

//   /* Specific styles for disabled select controls in edit mode */
//   .select__control--is-disabled {
//     background-color: #f8f9fa !important;
//     cursor: not-allowed;
//   }


//   /* ============================================================
//     TABLE STYLES
//     ============================================================ */
//   .table-wrapper {
//     max-height: 360px;
//     overflow-y: auto;
//     border: 1px solid #e0e6ed;
//     border-radius: 8px; 
//     background: #fff;
//   }

//   table {
//     width: 100%;
//     border-collapse: collapse;
//     font-size: 0.85rem; 
//   }

//   th, td {
//     padding: 10px 12px; 
//     text-align: left; 
//     border-bottom: 1px solid #f0f0f0;
//     white-space: nowrap;
//   }
//   th:first-child, td:first-child,
//   th:last-child, td:last-child {
//     text-align: center; 
//   }

//   th {
//     position: sticky;
//     top: 0;
//     background: #e9ecef; 
//     color: #495057; 
//     font-weight: 600;
//     z-index: 1;
//   }

//   tr:nth-child(even) { background: #f8f9fa; } 
//   tr:hover { background: #e9f5ff; } 

//   .delete-btn {
//     background: #dc3545; 
//     color: #fff;
//     border: none;
//     border-radius: 4px;
//     cursor: pointer;
//     font-weight: 500;
//     padding: 6px 10px;
//     font-size: 0.75rem;
//     transition: background-color 0.2s;
//   }
//   .delete-btn:hover { background: #c82333; }

//   /* ============================================================
//     MODAL STYLES (PROFESSIONAL LOOK)
//     ============================================================ */
//   .modal-overlay {
//     position: fixed;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: rgba(0, 0, 0, 0.6); 
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 1000;
//   }

//   .modal-content {
//     background: #fff;
//     padding: 24px; 
//     border-radius: 12px; 
//     width: 95%;
//     max-width: 500px; 
//     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); 
//     animation: fadeIn 0.3s ease-out;
//   }

//   @keyframes fadeIn {
//     from { opacity: 0; transform: scale(0.95) translateY(10px); }
//     to { opacity: 1; transform: scale(1) translateY(0); }
//   }

//   .modal-header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin-bottom: 20px;
//     border-bottom: 2px solid #f0f0f0; 
//     padding-bottom: 12px;
//   }

//   .modal-title {
//     font-size: 1.3rem;
//     font-weight: 700;
//     color: #1a3c69;
//     margin: 0;
//   }

//   .modal-close-btn {
//     background: none;
//     border: none;
//     font-size: 1.8rem;
//     cursor: pointer;
//     color: #6c757d; 
//     line-height: 1;
//     transition: color 0.2s;
//   }
//   .modal-close-btn:hover {
//     color: #333;
//   }

//   .modal-body .add-btn {
//     margin-top: 20px; 
//   }
  
//   /* ============================================================
//     RESPONSIVENESS
//     ============================================================ */
//   @media (max-width: 768px) {
//     .quantity-group { 
//       flex-direction: column; 
//       gap: 10px; 
//     } 
//     .modal-content {
//         max-width: 90%;
//         margin: 20px;
//     }
//   }
// `}</style>

//       <div className="header-with-button">
//         <h2 className="production-title">Production by Part</h2>
//         <div className="header-buttons">
//        <ExcelExport data={gridData} fileName="ProductionByPart" />

//           <button className="open-modal-btn" onClick={() => handleOpenModal()} disabled={loading}>
//             Add Part
//           </button>
//         </div>
//       </div>

//       <div className="table-wrapper">
//         {loading ? (
//             <p style={{textAlign: "center", padding: "20px"}}>Loading data...</p>
//         ) : gridData.length > 0 ? (
//           <table>
//             <thead>
//               <tr>
//                 <th>Sl No</th>
//                 <th>Part No</th>
//                 <th>Work Center</th>
//                 <th>Max Qty</th> 
//                 <th>Calibration Qty</th>
//                 <th>Total Prod</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {gridData.map((row, i) => (
//                 <tr key={i}>
//                   <td>{i + 1}</td>
//                   <td>{row.PartNo} ({row.PartDesc})</td>
//                   <td>{row.WcName}</td>
//                   <td>{row.MaxQty}</td>
//                   <td>{row.CalibrationQty}</td>
//                   <td>{row.TotalProd}</td>
//                   <td style={{ textAlign: 'center' }}>
//                     <button
//                       className="edit-btn"
//                       onClick={() => handleOpenModal(row)}
//                       disabled={loading}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       className="delete-btn"
//                       onClick={() => handleDelete(row.SeqId)}
//                       disabled={loading}
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         ) : (
//           <p
//             style={{
//               textAlign: "center",
//               color: "#6b7280",
//               marginTop: "8px",
//               fontSize: "0.85rem",
//               padding: "10px", 
//             }}
//           >
//             No parts added yet.
//           </p>
//         )}
//       </div>
      
//       <Modal 
//         isOpen={isModalOpen} 
//         onClose={handleCloseModal} 
//         title={editingItem ? "Edit Part Configuration" : "Add Production Part Configuration"} // Dynamic title
//       >
//         <div className="modal-body">
//          <div className="field-group">
//             <label className="production-label">Work Center</label>
//             <Select
//               options={wcOptions}
//               value={selectedWc}
//               onChange={setSelectedWc}
//               isClearable={!editingItem} 
//               isDisabled={loading || saving || !!editingItem} 
//               placeholder={loading ? "Loading..." : "Select Work Center..."}
//               classNamePrefix="select"
//             />
//           </div>

//           <div className="field-group">
//             <label className="production-label">Part No</label>
//             <Select
//               options={parts}
//               value={selectedPart}
//               onChange={setSelectedPart}
//               isClearable={!editingItem} 
//               isDisabled={loading || saving || !!editingItem} 
//               placeholder={loading ? "Loading..." : "Select Part No..."}
//               classNamePrefix="select"
//             />
//           </div>
          
//           <div className="quantity-group">
//             <div className="field-group">
//               <label className="production-label" htmlFor="max-qty">Max Qty</label>
//               <input
//                 id="max-qty"
//                 type="number"
//                 min="0"
//                 value={maxQty}
//                 onChange={(e) => setMaxQty(Number(e.target.value))}
//                 disabled={loading || saving}
//                 placeholder="0"
//               />
//             </div>

//             <div className="field-group">
//               <label className="production-label" htmlFor="calib-qty">Calibration Qty</label>
//               <input
//                 id="calib-qty"
//                 type="number"
//                 min="0"
//                 value={calibrationQty}
//                 onChange={(e) => setCalibrationQty(Number(e.target.value))}
//                 disabled={loading || saving}
//                 placeholder="0"
//               />
//             </div>
//           </div>


//           <button
//             className="add-btn"
//             onClick={handleSavePart} 
//             disabled={saving || loading || !selectedPart || !selectedWc}
//           >
//             {saving 
//               ? "Saving..." 
//               : editingItem 
//                 ? "Update Configuration" 
//                 : "Add Part to Asset"}
//           </button>
//         </div>
//       </Modal>

//     </div>
//   );
// }